'use client';

import { usePathname } from 'next/navigation';
import { useLanguage } from '@/contexts/LanguageContext';
import { EMAIL, LINKEDIN_URL } from '@/lib/site';
import { SERVICE_PAGES } from '@/lib/seo';
import Logo from './Logo';

const LinkedInIcon = () => (
	<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0Z" /></svg>
);
const MailIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></svg>
);

export default function Footer() {
	const { t } = useLanguage();
	const pathname = usePathname();
	const f = t.footer;
	const base = pathname === '/' ? '' : '/';
	const year = new Date().getFullYear();
	const serviceNames = [t.services.webTitle, t.services.mobileTitle, t.services.softwareTitle, t.services.saasTitle];

	return (
		<footer className="site-footer">
			<div className="wrap">
				<div className="f-grid">
					<div>
						<a className="brand" href={pathname === '/' ? '#home' : '/'} aria-label={f.homeAria}>
							<Logo />
							<span>Kuba <span className="gt">Studio</span></span>
						</a>
						<p className="tl">{f.tagline}</p>
						<p className="loc">{f.location}</p>
						<div className="social">
							<a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" aria-label={f.linkedinAria}><LinkedInIcon /></a>
							<a href={`mailto:${EMAIL}`} aria-label={f.emailAria}><MailIcon /></a>
						</div>
					</div>
					<div>
						<h4>{f.navLabel}</h4>
						<ul>
							<li><a href={`${base}#services`}>{f.services}</a></li>
							<li><a href={`${base}#realizations`}>{f.realizations}</a></li>
							<li><a href={`${base}#about`}>{f.about}</a></li>
							<li><a href={`${base}#contact`}>{f.contact}</a></li>
						</ul>
					</div>
					<div>
						<h4>{f.services}</h4>
						<ul>
							{SERVICE_PAGES.map((s, i) => (
								<li key={s.slug}><a href={`/services/${s.slug}/`}>{serviceNames[i]}</a></li>
							))}
						</ul>
					</div>
					<div>
						<h4>{f.projectsLabel}</h4>
						<ul>
							{['Coasso', 'Patrol', 'Novaccord', 'Picstat', 'Tivea'].map((name) => (
								<li key={name}><a href={name === 'Tivea' ? '/tivea/' : `${base}#realizations`}>{name}</a></li>
							))}
						</ul>
					</div>
					<div>
						<h4>{f.followLabel}</h4>
						<ul>
							<li><a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer"><LinkedInIcon />{f.linkedin}<span className="sr"> {f.newTab}</span></a></li>
							<li><a href={`mailto:${EMAIL}`}>{EMAIL}</a></li>
						</ul>
					</div>
				</div>
				<p className="wordmark gt" aria-hidden="true">Kuba Studio</p>
				<div className="f-bot">
					<span>© {year} Kuba Studio — {f.copyright}</span>
					<a href="/legal/">{f.legal}</a>
				</div>
			</div>
		</footer>
	);
}
